import React, { useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX } = FiIcons;

function EnchargeModal({ isOpen, onClose, formId, title, description }) {
  useEffect(() => {
    if (isOpen) {
      // Load Encharge script when modal opens
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.className = 'encharge-form-embed-script';
      script.src = 'https://resources-app.encharge.io/embed-production.min.js';
      document.head.appendChild(script);

      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';

      return () => {
        // Clean up script and restore scroll
        const existingScript = document.querySelector('.encharge-form-embed-script');
        if (existingScript) {
          existingScript.remove();
        }
        document.body.style.overflow = 'unset';
      };
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div>
            <h3 className="font-serif text-2xl text-gray-800 mb-2">
              {title}
            </h3>
            <p className="text-gray-600">
              {description}
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <SafeIcon icon={FiX} className="w-6 h-6" />
          </button>
        </div>

        {/* Form Content */}
        <div className="p-6">
          <div className="mb-6">
            <h4 className="font-semibold text-lg text-gray-800 mb-2">
              Get Your Free Resource
            </h4>
            <p className="text-gray-600 leading-relaxed">
              Enter your details below to receive your free download. We'll also send you helpful tips and resources for Christian authors.
            </p>
          </div>

          {/* Encharge Form */}
          <div 
            className="encharge-form-embed" 
            data-encharge-form-id={formId}
          ></div>
        </div>
      </div>
    </div>
  );
}

export default EnchargeModal;